import Repository from '@/repositories/marketing'
const resource = '/data_workflows'

export default {
  get(config) {
    return Repository.get(`${resource}.json`, config)
  },
  create(payload, config) {
    return Repository.post(`${resource}.json`,payload, config)
  },
  update(id, payload, config) {
    return Repository.put(`${resource}/${id}.json`, payload, config)
  },
  export(id) {
    return Repository.get(`${resource}/${id}/export.json`)
  },
  toggle(id) {
    return Repository.get(`${resource}/${id}/toggle_status.json`)
  },
  editJourney(id) {
    return Repository.get(`${resource}/${id}/edit.json`)
  },
  delete(config) {
    return Repository.delete(`${resource}/bulk_delete.json`, config)
  },
  duplicateJourney(id) {
    return Repository.get(`${resource}/${id}/duplicate.json`)
  }
}
